<template>
  <div class="main-wrapper" v-if="latestStableRelease">
    <h3>SiteServer CMS V6</h3>

    <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%">
      <div class="el-table__body-wrapper is-scrolling-none">
        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
          <colgroup>
            <col width="180" />
            <col />
          </colgroup>
          <tbody>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>最新版本</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">{{ latestNightlyRelease.version }}</div>
              </td>
            </tr>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>发布时间</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">{{ latestNightlyRelease.published }}</div>
              </td>
            </tr>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>稳定版本</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">{{ latestStableRelease.version }}</div>
              </td>
            </tr>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>发布时间</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">{{ latestStableRelease.published }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="el-table__column-resize-proxy" style="display: none"></div>
    </div>

    <div style="height: 10px"></div>

    <el-row>
      <el-alert type="warning" style="margin-bottom: 10px" v-if="latestNightlyVersion && isNotIn(latestNightlyVersion)">
        系统检测到CMS新版本，版本号：{{ latestNightlyVersion }}
        <el-button type="primary" plain style="margin-left: 0px" @click="btnPublishClick(latestNightlyVersion)">
          发 布
        </el-button>
      </el-alert>

      <el-button type="primary" plain style="margin-left: 0px" @click="btnPullClick">新版本检测</el-button>
    </el-row>

    <el-divider></el-divider>

    <h3>所有已发布的版本信息</h3>

    <el-table :data="releases" style="width: 100%">
      <el-table-column label="版本" width="180">
        <template v-slot="scope">
          {{ scope.row.version }}
        </template>
      </el-table-column>
      <el-table-column width="180" prop="published" label="更新日期"></el-table-column>
      <el-table-column label="发行说明" prop="releaseNotes"></el-table-column>
      <el-table-column label="操作" width="120">
        <template v-slot="scope">
          <el-link
            type="primary"
            :underline="false"
            :href="'https://dl.sscms.com/cms/' + scope.row.version + '/siteserver_install.zip'"
          >
            下 载
          </el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IRelease } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/v6';

interface IState {
  releases: IRelease[];
  latestNightlyRelease?: IRelease;
  latestStableRelease?: IRelease;
  latestNightlyVersion?: string;
  latestStableVersion?: string;
}

export default defineComponent({
  data() {
    return {
      releases: [],
      latestNightlyRelease: undefined,
      latestStableRelease: undefined,
      latestNightlyVersion: undefined,
      latestStableVersion: undefined,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.releases = res.releases;
        this.latestNightlyRelease = res.latestNightlyRelease;
        this.latestStableRelease = res.latestStableRelease;
      });
    },

    apiPublish(version: string) {
      api.publish(version, (res) => {
        this.releases = res.releases;
        this.latestNightlyRelease = res.latestNightlyRelease;
        this.latestStableRelease = res.latestStableRelease;

        utils.success(`新版本${version}发布成功！`);
      });
    },

    apiPull() {
      api.pull((res) => {
        this.latestNightlyVersion = res.latestNightlyVersion;
        this.latestStableVersion = res.latestStableVersion;
        utils.success('新版本检测成功！');
      });
    },

    isNotIn(version: string) {
      return this.releases.findIndex((o) => o.version === version) === -1;
    },

    btnPullClick() {
      this.apiPull();
    },

    btnPublishClick(version: string) {
      this.apiPublish(version);
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
